import Julie from './images/Julie.png'
import Fanny from './images/Fanny.png'

export default function julie_fanny() {
    let Julie_Fanny = <>
        <div className='solution-titre'>Parlons-nous !</div>
        <div className='julieEtFanny-container'>
            <div className='julieFanny-separate'>
                <div className='julie-fanny-photo'>
                    <img src={Julie}></img>
                </div>
                <h5>Julie Guillaume</h5>
                <p>Vice-présidente développement<br />et solutions innovantes</p>
                <a href='https://linktr.ee/algego'><div className='contacter'>CONTACTER</div></a>
            </div>
            <div className='julieFanny-separate'>
                <div className='julie-fanny-photo'>
                    <img src={Fanny}></img>
                </div>
                <h5>Fanny Sapparrart</h5>
                <p>Adjointe au développement<br />commercial et aux communications</p>
                <a href='https://linktr.ee/algego'><div className='contacter'>CONTACTER</div></a>
            </div>
      </div>
    </>;

    return Julie_Fanny;
}